/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { chipColorDecisionMaker } from "../../../utils/chipColorDecisionMaker";
import NoTrackingFound from "../../../../../assets/img/trackings.png";
import useWindowWidth from "../../../../../hooks/useWindowWidth";
import { Link } from "react-router-dom";
import DashboardTrackingsData from "./DashboardTrackingsData";
import ColoredMenuSVG from "../../../../../components/ColoredMenuSVG";
import { dummyTrackingsForSkeleton } from "../../orders/utils/dummyTrackingsForSkeleton";
import axiosProtected from "../../../../../api/config/baseWithToken";
import NewNotFound from "../../../components/NewNotFound";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function OrderTrackingTabs({ value, setValue, height, storeOwner }) {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [orderTrackings, setOrderTrackings] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const totaltrackingsByStatus = orderTrackings?.total_trackings_by_status;
  const trackings = orderTrackings?.trackings?.filter(
    (item) => item.status !== "Delivered"
  );

  const windowWidth = useWindowWidth();

  const tabChipStyle = {
    width: windowWidth <= 1500 ? "20px" : "20px",
    height: windowWidth <= 1500 ? "16px" : "16px",
    marginRight: "5px",
    fontSize: "8px",
  };

  const rootTabsStyle = windowWidth >= 1200 && {
    "& .MuiTab-root": {
      margin: "0 0",
      minWidth: windowWidth <= 1500 ? "43px" : "45px",
      padding: "0 8px",
      fontSize: windowWidth <= 1500 ? "10px" : "11px",
      "&.Mui-Selected": {
        margin: windowWidth <= 1500 ? "0 4px" : "0 5px",
        padding: "0 0",
      },
    },
  };

  const [isHovered, setIsHovered] = React.useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const color1 = isHovered ? "#8D40FF" : "#231f20";
  const color2 = isHovered ? "#fff" : "#c5c4c6";

  const mappedOrderTrackings = loading ? dummyTrackingsForSkeleton : trackings;

  const getOrderTrackings = React.useCallback(async (value) => {
    try {
      setLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const { data } = await axiosProtected.get(
        `/store/orders/order-trackings?status=${value?.status || "Warning"}`
      );
      setOrderTrackings(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    if(!storeOwner){

      getOrderTrackings();
    }
  }, [getOrderTrackings]);

  return (
    <Box
      sx={{
        paddingBottom: "10px",
        width: "100%",
        marginTop: "20px",
        background: "white",
        boxShadow:
          " 0px 2px 2px rgb(145 158 171 / 20%), 0px 12px 24px -4px rgb(145 158 171 / 12%)",
        borderRadius: "10px",
      }}
    >
      <Box sx={{}}>
        <Tabs
          value={value}
          sx={{
            position: "relative",
            zIndex: 1,
            width: "100%",
            background: "#eee",
            borderTopRightRadius: "8px",
            borderTopLeftRadius: "8px",
            ...rootTabsStyle,
          }}
          scrollButtons={false}
          allowScrollButtonsMobile
          variant="scrollable"
          onChange={handleChange}
          aria-label="basic tabs example"
          inkBarStyle={{ backgroundColor: "#000" }}
        >
          <Tab
            onClick={() => {
              getOrderTrackings({
                status: "Processing",
              });
            }}
            label={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: value === 0 && "700",
                  borderRadius: "5px",
                  padding: "3px",
                }}
              >
                {chipColorDecisionMaker(
                  "Process",
                  totaltrackingsByStatus?.totalProcessingTracks,
                  false,
                  tabChipStyle
                )}
                Processing
              </div>
            }
            {...a11yProps(0)}
          />
          <Tab
            onClick={() => {
              getOrderTrackings({
                status: "Shipped",
              });
            }}
            label={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: value === 1 && "700",
                  borderRadius: "5px",
                  padding: "3px",
                }}
              >
                {chipColorDecisionMaker(
                  "Ship",
                  totaltrackingsByStatus?.totalShippedTracks,
                  false,
                  tabChipStyle
                )}
                shipped
              </div>
            }
            {...a11yProps(1)}
          />
          <Tab
            onClick={() => {
              getOrderTrackings({
                status: "Warning",
              });
            }}
            label={
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: value === 2 && "700",
                  borderRadius: "5px",
                  padding: "3px",
                }}
              >
                {chipColorDecisionMaker(
                  "Attention",
                  totaltrackingsByStatus?.totalWarningTracks,
                  false,
                  tabChipStyle
                )}
                Attention
              </div>
            }
            {...a11yProps(2)}
          />

          <>
            <div
              style={{ position: "absolute", zIndex: 3, right: 10, top: 14 }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              <Link to="/customer/orders/order-tracking">
                <ColoredMenuSVG
                  text="order tracking"
                  color={color1}
                  color2={color2}
                />
              </Link>
            </div>
          </>
        </Tabs>
      </Box>
      <TabPanel
        value={value}
        index={0}
        style={{ height: height ? height : "auto" }}
      >
        <div style={{ padding: "20px", background: "white" }}>
          {!storeOwner && <DashboardTrackingsData
            trackings={mappedOrderTrackings}
            isLoading={loading}
          />}

          {!trackings && !loading && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "400px",
                justifyContent: "center",
                background: "white",
              }}
            >
              {/* {<NotFound
                margin="5%"
                loading={loading}
                content="trackings"
                subContent="Only processing orders will appear here"
              />} */}
              <NewNotFound
                title="No trackings found"
                width="250"
                img={NoTrackingFound}
                subTitle=" You currently have no orders processing"
              />
            </div>
          )}
        </div>
      </TabPanel>
      <TabPanel
        value={value}
        index={1}
        style={{ height: height ? height : "auto" }}
      >
        <div style={{ padding: "20px 20px 0px 20px", background: "white" }}>
          <DashboardTrackingsData
            trackings={mappedOrderTrackings}
            isLoading={loading}
          />

          {trackings?.length < 1 && !loading && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "400px",
                justifyContent: "center",
                background: "white",
              }}
            >
              <NewNotFound
                title="No trackings found"
                width="250"
                img={NoTrackingFound}
                subTitle="You currently have no orders in shipped status"
              />
            </div>
          )}
        </div>
      </TabPanel>
      <TabPanel
        value={value}
        index={2}
        style={{ height: height ? height : "auto" }}
      >
        <div style={{ padding: "20px", background: "white" }}>
          <DashboardTrackingsData
            trackings={mappedOrderTrackings}
            isLoading={loading}
          />

          {trackings?.length < 1 && !loading && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                height: "400px",
                justifyContent: "center",
                background: "white",
              }}
            >
              <NewNotFound
                title="No trackings found"
                width="250"
                img={NoTrackingFound}
                subTitle="You currently have no orders that need attention"
              />
            </div>
          )}
        </div>
      </TabPanel>

      {trackings?.length > 0 ? (
        <div style={{ textAlign: "center", marginTop: 10 }}>
          <Link to="/customer/orders/order-tracking">View more</Link>
        </div>
      ) : (
        <div
          style={{ textAlign: "center", marginTop: 10, visibility: "hidden" }}
        >
          <Link to="/customer/orders/order-tracking">View more</Link>
        </div>
      )}
    </Box>
  );
}
